export function trimCanvas (sourceCanvas) {
  const context = sourceCanvas.getContext('2d')
  if (!context) return null

  const { width, height } = sourceCanvas
  const { data } = context.getImageData(0, 0, width, height)

  let top = height
  let left = width
  let right = 0
  let bottom = 0

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const index = (y * width + x) * 4
      const red = data[index]
      const green = data[index + 1]
      const blue = data[index + 2]
      const alpha = data[index + 3]

      if (alpha > 0 && !(red > 250 && green > 250 && blue > 250)) {
        top = Math.min(top, y)
        left = Math.min(left, x)
        right = Math.max(right, x)
        bottom = Math.max(bottom, y)
      }
    }
  }

  if (right < left || bottom < top) return null

  const trimWidth = right - left + 1
  const trimHeight = bottom - top + 1
  const trimmedCanvas = document.createElement('canvas')
  trimmedCanvas.width = trimWidth
  trimmedCanvas.height = trimHeight
  trimmedCanvas.getContext('2d').drawImage(
    sourceCanvas,
    left,
    top,
    trimWidth,
    trimHeight,
    0,
    0,
    trimWidth,
    trimHeight
  )

  return trimmedCanvas
}

export function trimCanvasToDataUrl (sourceCanvas, type = 'image/png') {
  const trimmedCanvas = trimCanvas(sourceCanvas)
  return trimmedCanvas ? trimmedCanvas.toDataURL(type) : sourceCanvas.toDataURL(type)
}

export function trimImageElement (img) {
  if (!img.naturalWidth || !img.naturalHeight) return null

  const canvas = document.createElement('canvas')
  canvas.width = img.naturalWidth
  canvas.height = img.naturalHeight
  canvas.getContext('2d').drawImage(img, 0, 0)

  return trimCanvasToDataUrl(canvas)
}
